<div class="login-wrapper">

  <img *ngIf="backgroundImagePath" class="app-background" [src]="backgroundImagePath">
  <div class="login-container">
    <div class="login-header" *ngIf="logo">
      <eidos-icon class="login-header-logo" [iconConfiguration]="logo"></eidos-icon>
    </div> 
    <div class="mat-card auth-block">
      <div class="mat-card-content">
        <div class="login-token-icon">
          <eidos-icon *ngIf="isOnError" [iconConfiguration]="okIcon"></eidos-icon>
          <eidos-progress-spinner *ngIf="!isOnError" class="request-spinner" style="margin:0 auto;"></eidos-progress-spinner>
        </div>
        <h4 *ngIf="isOnError" class="login-token-message" [innerHTML]="getErrorMessage()"></h4>
        <h4 *ngIf="!isOnError" class="login-token-message">Logging in...</h4>
      </div>
    </div>
    <button *ngIf="isOnError" class="eidos-button eidos-button-normal eidos-button-success" type="button" (click)="goToLogin()">Go to login</button>
  </div>
</div>